import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=0dedcc08&scoped=true"
import script from "./sku.vue?vue&type=script&lang=js"
export * from "./sku.vue?vue&type=script&lang=js"
import style0 from "./sku.vue?vue&type=style&index=0&id=0dedcc08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedcc08",
  null
  
)

export default component.exports